import { render, staticRenderFns } from "./showScore.vue?vue&type=template&id=2b0cd8a4&"
import script from "./showScore.vue?vue&type=script&lang=js&"
export * from "./showScore.vue?vue&type=script&lang=js&"
import style0 from "./showScore.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports